var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0369 9.5659L7.06375 3.68104C6.6712 3.2943 6 3.56821 6 4.11515L6 15.8849C6 16.4318 6.6712 16.7057 7.06375 16.319L13.0369 10.4341C13.2803 10.1944 13.2803 9.80564 13.0369 9.5659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8889 4.11515V15.8849M7.06375 3.68104L13.0369 9.5659C13.2803 9.80564 13.2803 10.1944 13.0369 10.4341L7.06375 16.319C6.6712 16.7057 6 16.4318 6 15.8849L6 4.11515C6 3.56821 6.6712 3.2943 7.06375 3.68104Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueIcon);
export default __webpack_public_path__ + "static/media/continue-icon.863512c74e8d20df028016ee7b390aee.svg";
export { ForwardRef as ReactComponent };